import React, {useState} from 'react';
import './Home9.scss'

const Home9 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    const [toogleQuestion1, setToogleQuestion1] = useState(false);
    const [toogleQuestion2, setToogleQuestion2] = useState(false);
    const [toogleQuestion3, setToogleQuestion3] = useState(false);
    const [toogleQuestion4, setToogleQuestion4] = useState(false);
    const [toogleQuestion5, setToogleQuestion5] = useState(false);
    const [toogleQuestion6, setToogleQuestion6] = useState(false);

    const toggleQuestion = (questionNumber) => {
        // Si la pregunta ya está abierta, la cerramos
        if (questionNumber === 1) {
            setToogleQuestion1(!toogleQuestion1);
            setToogleQuestion2(false);
            setToogleQuestion3(false);
            setToogleQuestion4(false);
            setToogleQuestion5(false);
            setToogleQuestion6(false);
        } else if (questionNumber === 2) {
            setToogleQuestion2(!toogleQuestion2);
            setToogleQuestion1(false);
            setToogleQuestion3(false);
            setToogleQuestion4(false);
            setToogleQuestion5(false);
            setToogleQuestion6(false);
        } else if (questionNumber === 3) {
            setToogleQuestion3(!toogleQuestion3);
            setToogleQuestion1(false);
            setToogleQuestion2(false);
            setToogleQuestion4(false);
            setToogleQuestion5(false);
            setToogleQuestion6(false);
        } else if (questionNumber === 4) {
            setToogleQuestion4(!toogleQuestion4);
            setToogleQuestion1(false);
            setToogleQuestion2(false);
            setToogleQuestion3(false);
            setToogleQuestion5(false);
            setToogleQuestion6(false);
        } else if (questionNumber === 5) {
            setToogleQuestion5(!toogleQuestion5);
            setToogleQuestion1(false);
            setToogleQuestion2(false);
            setToogleQuestion3(false);
            setToogleQuestion4(false);
            setToogleQuestion6(false);
        } else if (questionNumber === 6) {
            setToogleQuestion6(!toogleQuestion6);
            setToogleQuestion1(false);
            setToogleQuestion2(false);
            setToogleQuestion3(false);
            setToogleQuestion4(false);
            setToogleQuestion5(false);
        }
    }

    const scroll = () =>{
        return sectionCurrently === Section.Section9 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }

    const mx = "nine-body-section fade-in-animation-9 disposition-column justify-start align-center";

    return (
        <>
                <div className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`} id = "section-9">
                    <div className = "nine-body-elements disposition-column justify-start align-center">
                        <p className = "title-1">Frequently Asked Questions</p>
                        <div className = "questions-general-section disposition-column justify-center align-center">
                            <div className = "questions-section disposition-column justify-start align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(1)}>
                                    <p className = "text-1">What documents do I need to apply for Karta?</p>
                                    <img src = { !toogleQuestion1 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img fade-in-animation-9" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion1 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content fade-in-animation-9 ${toogleQuestion1 ? 'open-toogle' : 'close-toogle'}`}>
                                    {
                                        toogleQuestion1 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                In order to apply for Karta, you must have an active US bank account, a copy of your passport, a utility bill, and a US VISA. In cases where a VISA is not required for entry into the US, a copy of your passport will suffice.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }
                                    
                                </div>
                            </div>
                            <div className = "questions-section disposition-column justify-center align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(2)}>
                                    <p className = "text-1">How does the 24/7 WhatsApp concierge service work?</p>
                                    <img src = { !toogleQuestion2 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion2 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content ${toogleQuestion2 ? 'open-toogle-2' : 'close-toogle-2'}`}>
                                    {
                                        toogleQuestion2 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                    Your Karta card is powered by AI and integrated with WhatsApp. We have a team of AI multi-agents that can assist you with various card-related tasks, from consulting past expenses to reporting possible fraud, locking/unlocking your card, and more.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }    
                                </div>
                            </div>
                            <div className = "questions-section disposition-column justify-center align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(3)}>
                                    <p className = "text-1">Can I apply to Karta without a Social Security Number (SSN)?</p>
                                    <img src = { !toogleQuestion3 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion3 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content ${toogleQuestion3 ? 'open-toogle-3' : 'close-toogle-3'}`}>
                                    {
                                        toogleQuestion3 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                    Yes! All we need is documentation to verify your identity and an active US bank account.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }    
                                </div>
                            </div>
                            <div className = "questions-section disposition-column justify-center align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(4)}>
                                    <p className = "text-1">How do virtual cards work and what are their benefits?</p>
                                    <img src = { !toogleQuestion4 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion4 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content ${toogleQuestion4 ? 'open-toogle' : 'close-toogle'}`}>
                                    {
                                        toogleQuestion4 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                    Virtual cards can be added to Apple Wallet and Google Wallet and can be used worldwide with any merchant that supports wallet payment transactions.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }    
                                </div>
                            </div>
                            <div className = "questions-section disposition-column justify-center align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(5)}>
                                    <p className = "text-1">What rewards and benefits does Karta offer?</p>
                                    <img src = { !toogleQuestion5 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion5 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content ${toogleQuestion5 ? 'open-toogle' : 'close-toogle'}`}>
                                    {
                                        toogleQuestion5 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                    The biggest benefit of KARTA is that it provides you with a US line of credit without requiring a SSN. Additionally, if you choose to, you have the option to build your U.S. credit history, among many other benefits that you can find on our website.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }    
                                </div>
                            </div>
                            <div className = "questions-section disposition-column justify-center align-center">
                                <div className = "elements-questions-section disposition-row justify-between align-center" onClick={() => toggleQuestion(6)}>
                                    <p className = "text-1">How can I monitor my spending and manage my account?</p>
                                    <img src = { !toogleQuestion6 ? "assets/Home/Home9/plus.png"  :  "assets/Home/Home9/menos.png" } className = "plus-img" alt =  "Plus"></img>
                                </div>
                                { !toogleQuestion6 && <hr className = "line"></hr> }
                                <div className={`toggle-question-content ${toogleQuestion6 ? 'open-toogle' : 'close-toogle'}`}>
                                    {
                                        toogleQuestion6 &&
                                        <>
                                            <div className="elements-questions-section disposition-row justify-start align-center">
                                                <p className="text-2">
                                                    You can monitor and manage your account directly on the Karta app or by asking your concierge on WhatsApp.
                                                </p>
                                            </div>
                                            <hr className = "line"></hr>
                                        </>
                                    }    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    );
};

export default Home9;
